import dayjs from 'dayjs'

import { childUsers, userWiseRole } from './constant'
import { entries, isEqual, keys, length, ternary } from './javascript'
import { getItem } from './localstorage'
import { sidebarMenus } from '../components/layout/sidebar.description'
import { countryLabels } from '../components/userManagement/addressData'

const addressFormat = data => {
  if (data?.pincode || data?.state || data?.city || data?.address) {
    return `${data?.address ? data?.address + ',' : ''} ${
      data?.city ? data?.city + ',' : ''
    } ${data?.state ? data?.state + ',' : ''} ${
      data?.country ? countryLabels[data?.country] + ',' : ''
    } ${data?.pincode ? data?.pincode : ''}`
  } else {
    return '-'
  }
}

const nameParam = ({ roleId, searchByEmail }) =>
  ternary(
    searchByEmail,
    'emailId',
    ternary(childUsers.includes(roleId), 'name', 'businessName'),
  )

const getAddEditRoles = pathName =>
  sidebarMenus.find(({ key }) => isEqual(key, pathName))?.addEdit || []

const apiParams = ({ params, pageNo }) => {
  let tempParams = ''
  if (pageNo) {
    tempParams += `${pageNo}`
  }
  entries(params).forEach(([key, value], i) => {
    tempParams += `${ternary(isEqual(i, 0), '?', '&')}${key}=${value}`
  })
  return tempParams
}

const userFromUserDetails = (data = JSON.parse(getItem('userData'))) => {
  const { children, parent } = userWiseRole
  const roleId = data?.roleId || data?.userDetails?.[0]?.roleId
  switch (roleId) {
    case children:
      const primaryData = data?.parent?.find(item =>
        isEqual(item?.primaryContact, item?.type),
      )
      return {
        father: data?.parent?.find(item => isEqual(item.type, 'FATHER')),
        mother: data?.parent?.find(item => isEqual(item.type, 'MOTHER')),
        ...data?.userDetails?.at(0),
        address: primaryData?.address,
        state: primaryData?.state,
        city: primaryData?.city,
        pincode: primaryData?.pincode,
        country: primaryData?.country,
        phoneNumber: primaryData?.phoneNumber,
        emailId: primaryData?.emailId,
      }

    case parent:
      return {
        father: data?.userDetails?.find(item => isEqual(item.type, 'FATHER')),
        mother: data?.userDetails?.find(item => isEqual(item.type, 'MOTHER')),
        ...data?.userDetails?.find(item =>
          isEqual(item?.primaryContact, item?.type),
        ),
      }

    default:
      return data?.userDetails?.[0]
  }
}

const getUserData = () => {
  const userDataObj = getItem('userData')
  const userData = JSON.parse(userDataObj || '{}')
  return { userData }
}

const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const getObjectDiff = (obj1, obj2) => {
  const compareObjects = (obj1, obj2) => {
    if (!obj1 || !obj2) return {}
    const diff = {}
    for (let key in obj1) {
      if (isEqual(undefined, obj2[key])) continue
      if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
        if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
          diff[key] = obj2[key]
          continue
        }
      } else if (
        typeof obj1[key] === 'object' &&
        typeof obj2[key] === 'object'
      ) {
        if (!obj1[key] || !obj2[key]) {
          diff[key] = obj2[key]
        } else if (
          //don't change dayjs with dayJs
          dayjs.isDayjs(obj2[key]) &&
          !obj1[key]?.isSame(obj2[key])
        ) {
          diff[key] = obj2[key]
          continue
        } else {
          const subDiff = compareObjects(obj1[key], obj2[key])
          if (length(keys(subDiff))) {
            diff[key] = subDiff
            continue
          }
        }
      } else if (obj1[key] !== obj2[key]) {
        diff[key] = obj2[key]
      }
    }
    return diff
  }
  return compareObjects(obj1, obj2)
}

export {
  addressFormat,
  apiParams,
  getAddEditRoles,
  getBase64,
  nameParam,
  userFromUserDetails,
  getObjectDiff,
  getUserData,
}
